import { isDevMode } from '@angular/core';
import { ActionReducerMap, createSelector, MetaReducer } from '@ngrx/store';
import * as appFeature from './app.reducer';
import { GlobalState } from '@smarsh-cyber/shared/models';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import { RouterStateUrl } from '@smarsh-cyber/shared/utils';

export interface AppState {
  app: GlobalState;
  router: RouterReducerState<RouterStateUrl>;
}

//TODO: add logout action when needed
//export const LogoutAction = createAction('LOGOUT');

export const reducers: ActionReducerMap<AppState> = {
  app: appFeature.reducer,
  router: routerReducer
};

//TODO: logout meta reducer - uncomment when we add logout
// const logoutState = (
//   reducer: ActionReducer<AppState>
// ): ActionReducer<AppState> => {
//   return function (state, action) {
//     if (action.type == LogoutAction.type) {
//       const user = state.app.user;
//       setTimeout(() => {
//         window.location.href = user.portalURL.concat(PORTAL_LOGOUT);
//       }, 0);
//       return reducer(undefined, action);
//     } else {
//       return reducer(state, action);
//     }
//   };
// };

// export const metaReducers: MetaReducer<AppState>[] = isDevMode()
//   ? [logoutState]
//   : [logoutState];

export const metaReducers: MetaReducer<AppState>[] = isDevMode() ? [] : [];

export const getRouterState = (state: AppState) => state.router;

export const getCurrentRouteState = createSelector(
  getRouterState,
  (state: RouterReducerState<RouterStateUrl>) => state.state
);

export * from './app.reducer';
export * from './di-token';
export * from './app.effects';
export * from './app.actions';
export * from './app.facade';
export * from './utils/app-state.translator';
